/**
 * @generated SignedSource<<10517c2427aef00217dc929576d05c0f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SourceType = "CODE_GITHUB" | "MANAGED" | "%future added value";
export type useCustomSkillsQuery$variables = {
  orgId: any;
};
export type useCustomSkillsQuery$data = {
  readonly node: {
    readonly customSkills?: ReadonlyArray<{
      readonly body: string | null | undefined;
      readonly description: string;
      readonly githubDirectoryPath: string | null | undefined;
      readonly githubRepoFullName: string | null | undefined;
      readonly id: any;
      readonly integration: {
        readonly id: any;
        readonly name: string;
      } | null | undefined;
      readonly name: string;
      readonly sourceType: SourceType;
    }>;
  } | null | undefined;
};
export type useCustomSkillsQuery = {
  response: useCustomSkillsQuery$data;
  variables: useCustomSkillsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orgId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "orgId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLCustomSkill",
      "kind": "LinkedField",
      "name": "customSkills",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "body",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sourceType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "githubRepoFullName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "githubDirectoryPath",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLIntegration",
          "kind": "LinkedField",
          "name": "integration",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v3/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GraphQLOrganization",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCustomSkillsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCustomSkillsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isNode"
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2a0e1c91e5876da9f0f35117f0bcf58e",
    "id": null,
    "metadata": {},
    "name": "useCustomSkillsQuery",
    "operationKind": "query",
    "text": "query useCustomSkillsQuery(\n  $orgId: GlobalID!\n) {\n  node(id: $orgId) {\n    __typename\n    ... on GraphQLOrganization {\n      customSkills {\n        id\n        name\n        description\n        body\n        sourceType\n        githubRepoFullName\n        githubDirectoryPath\n        integration {\n          id\n          name\n        }\n      }\n    }\n    __isNode: __typename\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "b4b9387a6b2dbdb3964c10f078d676a0";

export default node;
